import type { Database } from '@/types/database';

export type AppRole = Database['public']['Enums']['app_role'];
export type Profile = Database['public']['Tables']['profiles']['Row'];

export const APP_ROLES = ['SUPERADMIN', 'ADMIN', 'MEMBER'] as const satisfies readonly AppRole[];

export const roleLabels: Record<AppRole, string> = {
  SUPERADMIN: 'Superadministrador',
  ADMIN: 'Administrador',
  MEMBER: 'Miembro',
};
